import { z } from "zod";

export interface MotivoInList {
  id: number;
  tipo: string;
  tipoSolicitud: string;
  descripcion: string;
}

export interface MotivoDetail {
  idMotivo: number;
  descripcion: string;
  tiposMotivo: string[];
  tiposSolicitud: { id: string; descripcion: string }[];
  activo: boolean;
}

export const motivesSchema = z.object({
  descripcion: z.any().optional(),
  tipoMotivo: z.array(z.any().optional()).optional(),
  tipoSolicitud: z.array(z.any().optional()).optional(),
});
